<template>
    <article
        class="NewsCardFeatured"
    >
        <BaseImage
            :placeholder="item.placeholder"
            :srcset="item.imageVariant"
            :ratio="item.ratioVariant"
            classes="BaseImage--Cover"
        />
        <div class="NewsCardFeatured__content">
            <h2 class="uppercase text--white mb-spacer">{{ item.title }}</h2>
            <div v-html="item.description" />
            <BaseButton
                :href="item.url"
                modifier="ghost"
            >
                Read more
            </BaseButton>
        </div>
    </article>
</template>
<script>
export default {
    name: 'NewsCardFeatured',
    props: ['item'],
    computed: {
        classObject() {
            return {
                'NewsCard' : true,
                'NewsCard--event' : this.item.date !== null
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .NewsCardFeatured {
        @include media-query(lap-and-up) {
            display:-ms-grid;
            display: grid;
            -ms-grid-columns: 2fr 1fr;
            grid-template-columns: 2fr 1fr;
            -ms-grid-rows: 1fr;
            grid-template-rows: 1fr;
        }


    }

    .BaseImage {
        position: relative;

        &:after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: getColor('black');
            opacity: 0.15;
            transition: all ease-out 0.456s;
        }

        &:hover {
            &:after {
                opacity: 0.45;
            }
        }

        @include media-query(lap-and-up) {
            -ms-grid-column: 1;
            -ms-grid-row: 1;
            grid-column: 1;
            grid-row: 1;
        }
    }

    .NewsCardFeatured__content {
        background: $action-color;
        padding: getSpacing(spacer);

        @include media-query(lap-and-up) {
            padding: getSpacing(large) 2.5rem;
            -ms-grid-column: 2;
            -ms-grid-row: 1;
            grid-column: 2;
            grid-row: 1;
        }

        > div {
            color: getColor('white');
            line-height: 1.3;
        }
    }

    .BaseButton {
        margin-top: getSpacing(spacer);
    }
</style>
